import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import storage from 'libs/storage';
import store from '@/store';
import api from '@/api';
import { Dialog, Toast } from 'vant';
import utils from 'libs/utils';

Vue.use(Router);
const router = new Router({
  routes,
  mode: 'history',
});
const LOGIN_PAGE_NAME = 'login';
const homeName = 'index';
var checkLogin = (to, token, next, from) => {
	// console.log("eee1", to, token)
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    utils.setLastRouter(to)
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    }) 
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页 判断gid 是否一致
    next({
      name: homeName, // 跳转到homeName页
    });
  } else {
    next();
  }
};
router.beforeEach((to, from, next) => {
	// console.log("toooo", to)
  if (to.meta.showloading) {
    Toast.loading();
  }

  if (to.meta.bgcolor) {
    store.commit('setBgColor', to.meta.bgcolor);
  }
  //appInfo 原始链接
  utils.getToken().then(res=>{

    checkLogin(to, res, next, from);
  });

});
router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (window.__wxjs_is_wkwebview) {
    // IOS
    if (window.entryUrl === '' || window.entryUrl === undefined) {
      window.entryUrl = `${to.fullPath}`;
    }
  } else {
    // 安卓
    window.entryUrl = `${to.fullPath}`;
  }

  if (to.meta.showloading) {
    setTimeout(() => {
      Toast.clear();
    }, 500);
  }
  //处理分享
  utils.wxShareConf();

});

export default router;
